/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react'
// material
import { SectionGroupV2 } from 'material/expandablesection/v2'
import { Button } from '@insticator/insticator-ui'
import { ReactComponent as PencilIcon } from 'assets/icons/pencil.svg'
import PreviewConfig from '../../previewconfig/previewconfig'
import Avatar from '../../sitethemesection/components/avatar/avatar'
import Space from 'material/space/space'
// styles
import injectSheet from 'react-jss'
import styles from './publisheruser_styles'
import { useDispatch } from 'react-redux'
import { updateCurrentPage } from 'state/slices/app'


/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: ADVANCED SECTION : PUBLISHER USER ~~~~~~~~~~ ========== */
const PublisherUser = injectSheet(styles)((props) => {
  const dispatch = useDispatch()
  return (
    <SectionGroupV2 
      klass={`publisheruser ${props.classes.publisheruser}`}
      title={'Publisher Users'} 
      description={`
        Create and manage users who can interact with your community.
      `}
      indented
    >
      <div className='explainer'>
        <ul>
          <li>Users can be assigned special roles like Moderator, Editor, Writer, and Product Manager. Custom roles can be created to match any additional needs you have.</li>
          <li>Users are given special badging near their user names so the community can easily identify them as a representitive of your site.</li>
          <li>These users can comment, create <acronym title="Ask me anything">AMA</acronym> content, or even review comments via special access to our moderation tool.</li>
        </ul>
        <Button
          klass={'configbutton'}
          variant={'system'}
          text={'Configure'}
          handleClick={() =>  dispatch(updateCurrentPage('/dashboard/settings/users?view=publisherUser')) }
        />
      </div>
      <PreviewConfig>
      <Avatar name={'DEFAULT_1'} extension={'DEFAULT'} />
        <h3>WillieDixon</h3>
        <div className='editbutton'>
          <PencilIcon />
          <span>Editor</span>
        </div>
      </PreviewConfig>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default PublisherUser;